export default {
  user: {},
  loggedIn: false,
  userDataReady: false,
  permissions: [],
  kioskUser: {},
  kioskPermissions: [],
  invitations: {},
};
